import type { FC } from 'react';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useVoivodeships } from '../../hooks';
import { Select, SelectProps } from '../atoms';

export const VoivodeshipSelector: FC<Omit<SelectProps, 'name'>> = props => {
  const { getValues, setValue } = useFormContext();
  const voivodeships = useVoivodeships();

  useEffect(() => {
    if (voivodeships && voivodeships.length > 0) {
      const initialValue = getValues('voivodeship');
      const selectedExists = voivodeships.some(v => v.code == initialValue);
      
      if (selectedExists) {
        setValue('voivodeship', initialValue);
      } else {
        setValue('voivodeship', voivodeships[0].code);
      }
    }
  }, [voivodeships, getValues, setValue]);

  return (
    <Select
      {...props}
      block
      required
      label="voivodeship"
      name="voivodeship"
      options={voivodeships?.map(voivodeship => ({
        label: voivodeship.name,
        value: voivodeship.code,
      }))}
    />
  );
};
